export default __webpack_public_path__ + "static/media/pangolin.bc10c69d.webp";